// extracted by mini-css-extract-plugin
export var addressFields = "_nb-0";
export var animationContainer = "_nb-1";
export var footer = "_nb-2";
export var lineItems = "_nb-3";
export var modalContent = "_nb-4";
export var orderName = "_nb-5";
export var strong = "_nb-6";
export var warning = "_nb-7";